import type { PaymentProfileModel, UserModel } from '../Models/UserModel';
import { http } from './httpService';

export const UserService = {
  me: () => http.get<UserModel>('/me'),

  /** Premium: throws ApiError with code PREMIUM_REQUIRED without the plan. */
  getPaymentProfile: () => http.get<PaymentProfileModel>('/payment-profile'),

  savePaymentProfile: (profile: Partial<PaymentProfileModel>) =>
    http.put<PaymentProfileModel>('/payment-profile', profile)
};
